// extracted by mini-css-extract-plugin
export default {"content":"AuthenticationModal_content_xVbfY","notice":"AuthenticationModal_notice_DngHv"};